
import { defineComponent } from "vue";

export default defineComponent({
  name: "Section",
  props: {
    border: {
      type: Boolean,
      default: false,
    },
  },
});
